import classNames from 'classnames';

export interface ToggleProps {
  onChange?: (event) => void;
  checked: boolean;
  disabled?: boolean;
  name?: string;
  testId?: string;
}

/** @deprecated
 * This component is deprecated in favor of PositionedToggle, which doesn't
 * have positioning bugs like the current component.
 * */
export const Toggle = ({
  onChange,
  checked,
  disabled,
  name = 'toggle',
  testId,
}: ToggleProps) => {
  return (
    <label
      className={classNames(
        'relative w-full',
        disabled ? 'cursor-default' : 'cursor-pointer'
      )}
    >
      <input
        type="checkbox"
        name={name}
        className="hidden"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        data-testid={testId}
      />
      <span
        className={classNames(
          'absolute left-0.5 -top-0.5 w-2 h-2 rounded-full bg-ds-accent3-100 z-20 duration-300 ease-in-out',
          {
            'bg-ds-natural-200': disabled,
          }
        )}
        style={{
          transform: `translateX(${checked ? '14px' : '0'})`,
        }}
      />
      <span
        className={classNames(
          'absolute left-0 -top-1 right-0 bottom-0 w-ds-26 h-3 rounded-full z-0 transition-colors transform duration-200',
          {
            'bg-ds-natural-150': disabled,
            'active:bg-gradient-to-r active:from-ds-primary-500 active:to-ds-natural-200':
              !disabled,
            'hover:bg-ds-primary-400 bg-ds-primary': checked && !disabled,
            'bg-ds-natural-300 hover:bg-ds-natural-400': !checked && !disabled,
          }
        )}
      />
    </label>
  );
};
